import { FSA } from '../constants';

export const TOGGLE_FULLSCREEN = 'APP_TOGGLE_FULLSCREEN';
export const toggleFullscreen = (): FSA => ({ type: TOGGLE_FULLSCREEN });
